import './App.css';
import ContactUs from './components/ContactUs';
import Hero from './components/Hero';

const App = () => {
  return (
    <div className = "App">
      <Hero />
      <ContactUs />
    </div>
  );
}
// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           20230308 <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="tel:+639997504533"
//           // target="_blank"
//           // rel="noopener noreferrer"
//         >
//           Call Me
//         </a>
//       </header>
//     </div>
//   );
// }

export default App;
